// Moved unchanged out of CaseBriefPage.js (ticket 072).
import React, { useState } from 'react'

// ── Contact display — email + phone (D5, ticket 008) ────────────────────────
// Same pattern for both: a link (mailto:/tel:) + a copy-to-clipboard button.
// Reuses .brief-header-email/.brief-header-email-link/.brief-header-copy-btn
// as-is — named as if email-specific but generic enough for phone too; a
// rename pass is a fast-follow if a third contact method ever shows up here.

export function ContactDisplay({ value, href, copyTitle }) {
  const [copied, setCopied] = useState(false)

  function copyValue(e) {
    e.preventDefault()
    navigator.clipboard.writeText(value).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  return (
    <div className="brief-header-email">
      <a href={href} className="brief-header-email-link">{value}</a>
      <button className="brief-header-copy-btn" onClick={copyValue} title={copyTitle}>
        {copied ? '✓' : '⧉'}
      </button>
    </div>
  )
}

export function EmailDisplay({ email }) {
  return <ContactDisplay value={email} href={`mailto:${email}`} copyTitle="Copy email address" />
}

export function PhoneDisplay({ phone }) {
  return <ContactDisplay value={phone} href={`tel:${phone}`} copyTitle="Copy phone number" />
}
